export default __webpack_public_path__ + "static/media/blind.3ed7e890.png";